export default __webpack_public_path__ + "static/media/webTraderIcon2.8da1d938.webp";